var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.7,23.9c-0.1,0-0.3,0-0.4-0.1l-4.5-2.4l-4.5,2.4c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2,0-0.2,0l0,0h-0.4 v-0.2l-4.3-2.3l-4.5,2.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-0.2-0.1-0.4-0.4-0.4-0.7V10.5c0-0.3,0.2-0.6,0.4-0.7 l1.7-1c0.2,0,0.3-0.1,0.5-0.1c0.3,0,0.5,0.2,0.7,0.4c0.1,0.2,0.1,0.4,0,0.6c-0.1,0.2-0.2,0.4-0.4,0.5L3,10.9v11l3.3-1.8v-4.4 c0-0.4,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v4.4l3.3,1.8v-11l-1.3-0.8c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.2,0-0.4,0.1-0.6 c0.1-0.3,0.4-0.4,0.7-0.4c0.1,0,0.3,0,0.4,0.1L12,9.6l4.5-2.4l0,0c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0 s0.1,0,0.2,0.1l0,0l4.9,2.6c0.3,0.1,0.4,0.4,0.4,0.7v12.7c0,0.3-0.1,0.5-0.4,0.7l0,0C22,23.9,21.8,23.9,21.7,23.9L21.7,23.9z  M12.7,21.9l3.3-1.8v-11l-3.3,1.8C12.7,10.9,12.7,21.9,12.7,21.9z M20.9,21.9v-11l-3.3-1.8v11L20.9,21.9L20.9,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.6,3.6c0-1.9-1.6-3.5-3.5-3.5S3.5,1.7,3.5,3.6s3.5,8.6,3.5,8.6S10.6,5.5,10.6,3.6L10.6,3.6L10.6,3.6z  M4.8,3.9c0-1.2,1.1-2.3,2.3-2.3s2.3,1.1,2.3,2.3S8.3,6.2,7.1,6.2S4.8,5.1,4.8,3.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.814b28292b3b5c12a401f2d39aeec60b.svg";
export { ForwardRef as ReactComponent };